import React from 'react';

interface Props {
  className?: string;
}

/**
 * Bandeau du bas, présent sur tous les écrans.
 *
 * La plateforme est un outil du programme : les trois signatures — le PEV, le
 * ministère de tutelle, et OmnIA qui l'opère — restent visibles quel que soit
 * l'écran ouvert.
 */
const BandeauInstitutionnel: React.FC<Props> = ({ className = '' }) => (
  <footer
    className={`border-t border-eg-bordure bg-eg-blanc/90 backdrop-blur ${className}`}
  >
    <div className="flex flex-col items-center gap-1 px-4 py-2">
      <div className="flex items-center justify-center gap-6">
        <img
          src="/logos/pev.png"
          alt="Programme Élargi de Vaccination — Guinée"
          className="h-8 w-auto object-contain"
        />
        <img
          src="/logos/ministere-sante.png"
          alt="Ministère de la Santé et de l'Hygiène Publique"
          className="h-8 w-auto object-contain"
        />
        <img src="/logo-omnia.svg" alt="OmnIA" className="h-6 w-auto" />
      </div>
      <p className="text-center text-[10.5px] leading-snug text-eg-estompe">
        Programme Élargi de Vaccination · Ministère de la Santé et de l'Hygiène Publique
        <span className="hidden md:inline"> · République de Guinée</span>
      </p>
    </div>
  </footer>
);

export default BandeauInstitutionnel;
